import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { type RootState } from '@/store';
import { CasesBasicItem } from '@/api';

interface CasesBasicState {
  casesBasicList: CasesBasicItem[];
}

const initialState: CasesBasicState = {
  casesBasicList: []
};

const casesBasicSlice = createSlice({
  name: 'casesBasic',
  initialState: initialState,
  reducers: {
    setCasesBasicList: (state, action: PayloadAction<CasesBasicItem[]>) => {
      state.casesBasicList = action.payload;
    }
  }
});

export const { setCasesBasicList } = casesBasicSlice.actions;

export const selectCasesBasicList = (state: RootState) => {
  return state.casesBasic.casesBasicList;
};

export const casesBasicReducer = casesBasicSlice.reducer;
